import { useNavigate, useLocation, useParams } from 'react-router-dom';

/**
 * Higher Order Component to bridge React Router v6 hooks to v5 routerProps pattern
 * This allows legacy components expecting routerProps to work with React Router v6
 */
export const withRouterProps = (Component) => {
  return (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    // Create history object compatible with React Router v5
    const history = {
      push: (path, state) => navigate(path, { state }),
      replace: (path, state) => navigate(path, { replace: true, state }),
      go: (n) => navigate(n),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      location: location
    };

    // Create match object compatible with React Router v5
    const match = {
      params: params,
      isExact: true,
      path: location.pathname,
      url: location.pathname
    };

    // Create routerProps object in the format expected by legacy components
    const routerProps = {
      history,
      location,
      match
    };

    return <Component {...props} routerProps={routerProps} />;
  };
};
